<template>
    <div  class="p-4">
        <l-container>
            <l-container-title slot="toolbar" text="Namespace" icon="cog" color="bg-pastel-green-500" />
            <div class="flex w-full">    
                <div class="w-1/4 mr-2">
                    <l-input placeholder="Input a namespace" inputClass="text-2xs" v-model="namespace"  />
                </div>
                <div class="w-1/4">
                    <l-button type="success" :disabled="namespace.length == 0" @click="onSave">Change namespace</l-button>
                </div>
            </div>
        </l-container>
    </div>
</template>

<script>
import { LButton, LInput } from "@/components/forms";
import Notify from "@/helpers/notify";
import NamespaceService from "@/helpers/services/namespace/namespace.service"

export default {
    name:'Namespace',
    components: { LButton, LInput },    
    data() {
        return {
            namespace: ''
        };
    },
    mounted () {
        Notify.loadData(null, this.loadInitialData);
    },
    methods: {
        async loadInitialData() {
            const res = await NamespaceService.get();
            this.namespace = res.namespace;
        },
        async onSave() {
            Notify.loadData("Saving namespace", async () =>  { 
                await NamespaceService.save(this.namespace);
                Notify.success("Namespace changed!");
            });
        }
    }
}
</script>

<style>

</style>